import { render, staticRenderFns } from "./SpyderInstagramIcon.vue?vue&type=template&id=0e5be294"
import script from "./SpyderInstagramIcon.vue?vue&type=script&lang=js"
export * from "./SpyderInstagramIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports